/**
 * Presentational body for LoadingOverlay (keeps overlay component under line limits).
 * For Media Devoted | Created By Ciro Autiero
 */

import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface LoadingOverlayBodyProps {
  title: string;
  description?: string;
  className?: string;
  lottieSlot: ReactNode;
}

export function LoadingOverlayBody({
  title,
  description,
  className,
  lottieSlot,
}: LoadingOverlayBodyProps) {
  return (
    <div
      className={cn(
        'fixed inset-0 z-50 flex items-center justify-center',
        'bg-background/70 backdrop-blur-sm',
        className,
      )}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="flex w-full max-w-md flex-col items-center gap-3 px-6 text-center">
        {lottieSlot}
        <div className="text-base font-semibold text-foreground">{title}</div>
        {description ? <div className="text-sm text-muted-foreground">{description}</div> : null}
        <span className="sr-only">{title}</span>
      </div>
    </div>
  );
}
